import svg4everybody from 'svg4everybody';
import { APP_NAME } from './utils/environment';

export default function() {
    svg4everybody();

    window[APP_NAME] = window[APP_NAME] || {};
    window[APP_NAME].l10n = window[APP_NAME].l10n || {};
}
